import { useNavigate } from 'react-router-dom'
import Button from '@/common/components/Button'
import { ManualEntryProposalShowData } from '../../../types/maintenanceManualEntryProposal.type'

type Props = {
  proposal: ManualEntryProposalShowData
  onAccepted?: () => void
}

const ExecutionProposalAction = ({ proposal }: Props) => {
  const navigate = useNavigate()

  return (
    <Button
      operationKlassToCheckPermission="Establishment::Maintenance::EstablishmentChoice::ManualEntryProposals::EstablishmentAccept"
      onClick={() => navigate(`/maintenance-proposals/${proposal.id}/execution-proposal`)}
    >
      Adicionar proposta
    </Button>
  )
}

export default ExecutionProposalAction
